import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class UserServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  /**
   * TODO :: Переделать после полного переезда на SPA
   * Метод: PUT /users/1 - уже есть и используется в CORE
   * Как откажемся от Core - вернуть к нормальногому виду
   */

  getUserInfo(user_id) {
    return this.http.get(`${user_id}`);
  }

  editItem(user_id, data) {
    return this.http.put(`${user_id}/update`, data);
  }

  setLocale(user_id, locale) {
    return this.http.put(`${user_id}/locale`, { locale });
  }

  setPaymentInfo(user_id, data) {
    return this.http.put(`${user_id}/payment`, data);
  }

  changePassword(user_id, data) {
    return this.http.put(`${user_id}/password`, data);
  }

  changeServicePackage(user_id, params = {}) {
    return this.http.put(`${user_id}/service-package`, params);
  }
}

export const UserService = new UserServiceClass({
  api_version: 2,
  resource: 'users'
});
